// extracted by mini-css-extract-plugin
module.exports = {"stack":"FinanceCalculator_stack__M1rEh","calculator":"FinanceCalculator_calculator__Cgpzc"};